var CheckOutPath = "CheckOut";
var CheckOutAddressPath = "CheckOutAddress";
var CheckOutValidator = "CheckoutValidation";
var CheckoutPayment = "CheckoutPayment";
var isSingleLineCreditCard = false;

function ShowInstallmentByBankCode(BankCode, cardType, BankLogoPath) {
    var activeCls = $("#PaymentGroups .PaymentGroupItem.active:first input:first").attr("data-payment");

    console.warn("Durum-3 " + BankCode + "*" + "--" + cardType + "*" + "--" + BankLogoPath + "*--" + activeCls);



    $("#PosGroups .PosGroupItem").hide();

    switch (cardType) {


        case "Credit":
            if (activeCls != "KrediKarti") {

                AutoFillBankLogo = BankLogoPath;
                activeCls = "KrediKarti";

                $(".PaymentGroupSelectNew li").removeClass("active");
                $(".PaymentGroupSelectNew li a.KrediKarti").parent().addClass("active");
                $(".PaymentGroupSelectNew li a input").removeAttr("checked");
                $(".PaymentGroupSelectNew li a.KrediKarti input").attr("checked", "checked");
                $(".PaymentGroupSelectNew li a.KrediKarti input").trigger("change");
                console.warn("Durum-4");
                if (BankLogoPath != undefined && BankLogoPath != "") {

                    $("div#CreditCardLogo > img").show();
                    $("div#CreditCardLogo > img").attr("src", "/ContentImages/Banks/" + BankLogoPath);
                }

            }
            break;

        case "Debit":
            if (activeCls != "DebitCard") {

                console.warn("Durum-5");
                AutoFillBankLogo = BankLogoPath;

                activeCls = "DebitCard";

                $(".PaymentGroupSelectNew li").removeClass("active");
                $(".PaymentGroupSelectNew li a.DebitCard").parent().addClass("active");

                $(".PaymentGroupSelectNew li a input").removeAttr("checked");
                $(".PaymentGroupSelectNew li a.DebitCard input").attr("checked", "checked");

                //Debite Geçiş
                $(".PaymentGroupSelectNew li a.DebitCard input").trigger("change");

                if (BankLogoPath != undefined && BankLogoPath != "") {

                    $("div#CreditCardLogo > img").show();
                    $("div#CreditCardLogo > img").attr("src", "/ContentImages/Banks/" + BankLogoPath);

                }



            }

            break;

    }

    $(".Installments ul").hide();

    if (activeCls == "KrediKarti") {
        $(".Installments ul.InstallmentHeader").show();
    } else {
        $(".AllInstallments").hide();
        $("#PaymentBanners").hide();
    }

    //Banka kredi kartı title
    $(".Installments .BarInner span").hide();
    $(".Installments .BarInner span." + activeCls).show();

    var cardown = $("#CardOwner:first").val();

    //Amex ve ShopAndMiles Taksit gösterme, ama garantiden geç
    var isAmex = false;
    var isShopAndMiles = false;
    if (LastCardName.toUpperCase().indexOf("AMEX") > -1) isAmex = true;
    if (LastCardName.toUpperCase().indexOf("MASTER SM") > -1 || LastCardName.toUpperCase().indexOf("VISA SM") > -1) isShopAndMiles = true;
    if (isAmex || isShopAndMiles) BankCode = "62";

    //Banka koduna ait taksit seçeneği varsa
    if ($(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "']").length > 0 && cardown.toUpperCase() != "BÜTÜN POSLAR") {

        //console.log("qwqeqweqweqe");

        $("#PosGroups .PosGroupItem[data-rel='" + BankCode + "']").show();
        $("#PosGroups .PosGroupItem[data-rel='" + BankCode + "']").addClass("active");

        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "']").show();
        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li").show();

        //Pos başlık logo ile birlikte göster/gizle hide olduğunda sadece taksitler görünür.
        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] .PosHeader").show();
        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").attr("checked", "checked");
        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").trigger("change");
        $(".Installments ul.InstallmentHeader").show();

        if (isAmex || isShopAndMiles) {

            $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li").hide();
            $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li.FirstInstallment").show();

        }

    }
    else {

        //Banka koduna ait taksit seçeneği YOKSA tek çekim göster 
        if (cardown != "BÜTÜN POSLAR") {

            //console.log("<> activeCls:", activeCls, " BankCode:", BankCode);

            //if (BankCode != -1 && BankCode != 0)
            //{

            //    $("#PosGroups .PosGroupItem[data-webposid='other']").show();
            //    $("#PosGroups .PosGroupItem[data-webposid='other']").addClass("active");

            //    $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li").hide();
            //    $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] .PosHeader").hide();
            //    $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "']:first").show();
            //    $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first").show();
            //    $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").attr("checked", "checked");
            //    $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").trigger("change");
            //    $(".Installments ul.InstallmentHeader").hide();
            //}
            //else {
            //    console.log("geldiiiiiiiii");
            $(".Installments ul.DefaultPos").show();
            $(".Installments ul.DefaultPos").find("li.FirstInstallment:first input").attr("checked", "checked");
            $(".Installments ul.DefaultPos").find("li.FirstInstallment:first input").trigger("change");

            //}



        }
        else {

            //--------------------------------------------------------------------------------------------------------------------- 
            //Banka koduna ait taksit seçeneği YOKSA tüm taksitleri göster 
            $(".Installments ul[data-cardtype='" + activeCls + "']").show();
            $(".Installments ul[data-cardtype='" + activeCls + "'] li").show();
            $(".Installments ul[data-cardtype='" + activeCls + "'] .PosHeader").show();
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").attr("checked", "checked");
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").trigger("change");
        }


    }


}

var firstBin = "";
var lastBin = "";
var AutoFillCard1 = "";
var AutoFillBankCode = "-1";
var AutoFillCard2 = "";
var AutoFillName = "";
var AutoFillBankLogo = "";
var LastCardName = "";

function CheckBinNumber(t, t_1, t_2) {

    var t_1 = $("#CardNumbers > input#CardNumber1").val().replace(/\D/g, '');
    var t_2 = $("#CardNumbers > input#CardNumber2").val().replace(/\D/g, '');
    var t_3 = $("#CardNumbers > input#CardNumber3").val().replace(/\D/g, '');
    var t_4 = $("#CardNumbers > input#CardNumber4").val().replace(/\D/g, '');

    var t = (t_1 + t_2);

    if (t.length >= 8 && (isSingleLineCreditCard || (t_1.length == 4 && t_2.length >= 4))) {

        var tval6 = t.substring(0, 8);
        lastBin = tval6;

        if (lastBin != firstBin) {

            $.ajax({
                url: "/" + CheckoutPayment + "/CardDetails",
                dataType: 'json',
                async: true,
                data: "BinNo=" + tval6,
                success: function (jsonReturn) {

                    if (jsonReturn.length !== 0) {

                        $.each(jsonReturn, function (index, element) {
                            var ax = (element.ID + "-");

                            $("div#CreditCardLogo > img").show();
                            $("div#CreditCardLogo > img").attr("src", "/ContentImages/Banks/" + element.BankLogoPath);

                            bnkCode = element.BankCode;
                            cardType = element.CardType;
                            AutoFillBankCode = bnkCode;
                            var LogoPath = element.BankLogoPath;
                            console.warn(element);
                            if (element.CardLogoPath != undefined && element.CardLogoPath.length > 0) {
                                LogoPath = element.BankLogoPath;
                            }

                            LastCardName = element.CardName;
                            ShowInstallmentByBankCode(bnkCode, cardType, LogoPath);


                        });

                    }
                    else {
                        var cType = $("#PaymentGroups > label > input[name='PaymentGroup']:checked").data("payment");
                        var card = "";

                        if (cType == "KrediKarti") {
                            card = "Credit";
                        }
                        else if (cType == "DebitCard") {
                            card = "Debit";
                        }

                        console.warn("Durum-2" + "**" + card);
                        bnkCode = "-1";
                        AutoFillBankCode = "-1";
                        ShowInstallmentByBankCode(bnkCode, -1, "");
                    }


                }


            });

            firstBin = lastBin;

        }
    }
}



function formatCC(value) {
    var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || ''
    var parts = []
    for (i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4))
    }
    if (parts.length) {
        return parts.join(' ')
    } else {
        return value
    }
}

function validateCardNumber(number) {
    var regex = new RegExp("^[0-9]{16}$");
    if (!regex.test(number))
        return false;

    return luhnCheck(number);
}

function luhnCheck(val) {
    var sum = 0;
    for (var i = 0; i < val.length; i++) {
        var intVal = parseInt(val.substr(i, 1));
        if (i % 2 == 0) {
            intVal *= 2;
            if (intVal > 9) {
                intVal = 1 + (intVal % 10);
            }
        }
        sum += intVal;
    }
    return (sum % 10) == 0;
}

function IsNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function ReloadOnTimeOut(dt) {

    if (dt != undefined) {

        //timeout no state found reload
        if (dt.StatusText == "CheckOutStateTimeOut" || dt.StatusText == "Reload") {

            $(".AjaxLoader").show();
            document.location.reload(true);
        }
    }
}

function PrepareAddressAndPayment() {

    if ($("#CurStep").length > 0) {


        var step = $("#CurStep").val();

        var url = "";

        if (step == "Sepet") {
            url = "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/PrepareUserAdresses";
        }

        if (step == "Adres") {
            url = "/" + $("#SmallLangCode").val() + "/p/CheckOutPayment/PreparePayment";
        }

        if (url.length > 0) {
            $.ajax({
                type: 'post',
                url: url,
                success: function (dt) {

                }
            });
        }

    }
}


function SetPaymentType(webPosInstallmentID, BankID) {

    if (BankID == undefined) { BankID = 0; }

    $.ajax({
        type: 'post',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutPayment/SetPaymentType?webPosInstallmentID=" + webPosInstallmentID + "&bankID=" + BankID,
        success: function (dt) {

            ReloadOnTimeOut(dt);

            if (dt.Status) {

                RefreshOrderSummary(false, false);

            } else {

                SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
            }
        }

    });

}

function ReloadPure() {
    $(".AjaxLoader").show();
    $(".container").css("opacity", "0.5");
    document.location.reload(true);
}

function ReloadPage() {

    $(".AjaxLoader").show();
    $(".container").css("opacity", "0.5");

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + '/p/CheckOutCart/RemoveCoupon',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function (dt) {
            //console.log(dt);
        }
    });


    document.location.reload(true);

}

function SetErrorResults(target, errors, clear, slideDown) {


    $('html,body').animate({ scrollTop: 0 }, 'slow', function () { });

    if (clear) {
        $(target).html("");
    }

    if (errors != undefined && errors.length > 0) {

        for (var i = 0; i < errors.length; i++) {
            if (errors[i] != "" && errors[i] != undefined && errors[i] != null) {
                $(target).append("- &nbsp;" + errors[i] + "<br />");
            }

        }

        if (slideDown) {

            $(target).show();
        }
        else {
            $(target).show();
        }
    }

}

function GetAddressForm(url) {

    if ($("#AddressArea").length > 0) {

        $.ajax({
            type: "GET",
            cache: false,
            url: url,
            success: function (dt) {

                ReloadOnTimeOut(dt);
                $("#AddressArea").html(dt);
                HandleAddressInputs();

            }
        });

    }
}

function GetAdressFromFirstLoad() {

    if ($(".loadform").length > 0) {
        var url = "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/EditOrCreate";
        GetAddressForm(url);
    }

}

function RefreshOrderSummary(animateTop, showCouponLine) {


    $.ajax({
        type: 'get',
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/" + CheckOutPath + "/summary",
        success: function (dt) {
            $("#OrderSummary").html(dt);
            //console.log(dt);
            //console.log(showCouponLine);
            if (showCouponLine) {

                $(".CouponLine").hide();
                $(".CouponLine").show("slow");
                //console.log($("#CouponModal").length);
                if ($("#CouponModal").length > 0) {
                    $("#CouponModal").modal("hide");
                }
            }

            //if (animateTop) {
            //    $('html,body').animate({ scrollTop: 2000 }, 'slow', function () { });
            //}

        }

    });



}

function RefreshCargoList() {

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/GetCargoList",
        success: function (dt) {
            $("#CargoList").html(dt);
        }

    });
}

function HandleAddressInputs() {

    if ($(".OrderAdressForm").length > 0) {

        if ($(".OrderAdressForm #Phone2").length > 0) {

            //console.log($(".OrderAdressForm #Phone2").text().length);

            if ($(".OrderAdressForm #Phone2").val().length <= 0) {
                $(".OrderAdressForm #Phone2").val("0");
            }

            $(".OrderAdressForm #Phone2").mask("0999 999 99 99");
        }
    }
}

function UseCoupon(couponCode) {

    $.ajax({
        type: 'get',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutCart/AddCoupon?couponCode=" + couponCode,
        success: function (dt) {

            ReloadOnTimeOut(dt);

            if (dt.Status == true) {
                //Sipariş özetini Yenile
                RefreshOrderSummary(true, true);

                $("#OrderCoupons tr").removeClass("added");
                $("#OrderCoupons tr button[data-value=" + couponCode + "]").closest("tr").addClass("added");

            }
            else {

                SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
            }
        }

    });

}




function SetCreditCartAndStep(adim, href) {

    if ($("#CardForm").length > 0) {



        $form = $("#CardForm");

        //console.log($form.serialize());


        $.ajax({
            type: 'post',
            async: true,
            cache: false,
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetCreditCard",
            data: $form.serialize(),
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    SetStep(adim, href);
                    //Sipariş özetini Yenile
                    //RefreshOrderSummary(true, true); 
                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                }

            }

        });



    }
}

function SetStep(adim, href) {
    if((typeof adim != 'undefined')) {
        
    var OrdNote = "";
    if ($("#OrderNoteText").length > 0) {
        OrdNote += "OrderNote=" + $("#OrderNoteText").val();
    }

    $.ajax({
        type: 'POST',
        cache: false,
        url: "/" + SmallLangCode + "/p/" + CheckOutValidator + "/SetStep?step=" + adim,
        data: OrdNote,
        success: function (dt) {

            ReloadOnTimeOut(dt);
            //console.log(dt);
            if (dt.Status == false) {

                //ask for login or memberless
                if (dt.ReturnCode == 12) {

                    $("#LoginRegisterModal").modal();
                }

                //Edit Address Or Create Address
                if ($("#AddressArea").length > 0 && (dt.StatusText == "MissingAddress" || dt.StatusText == "InvalidAddress")) {

                    var url = "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/EditOrCreate?id=0";
                    //console.clear();
                    //console.log(id);

                    GetAddressForm(url);

                } else if (dt.Status == false) {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                }

            }

            if (dt.Status == true) {

                $("#Steps button, #Steps .StepName, #nextbtn, .Bottom #nextbtn, #backbutton, .Bottom #backbutton").attr("disabled", "disabled");

                //hata yoksa ve progress ise bekleyinizi göster
                if (adim == "progress") {

                    $("#nextbtn, .Bottom #nextbtn, #backbutton,  .Bottom #backbutton").text($("#PleaseWait").val());

                    $(".AjaxLoaderDiv").css("left", "44%");

                }

                //goto next step
                document.location.href = "/" + SmallLangCode + "/p/" + CheckOutPath + "/" + adim;

            }
        }

    });

    }

}


function startTimer(duration, display) {
    var timer = duration, minutes, seconds;
    setInterval(function () {
        minutes = parseInt(timer / 60, 10)
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        if (minutes == "00" && seconds == "00") {
            window.location.reload(false);
        }

        display.html(minutes + ":" + seconds);

        if (--timer < 0) {
            timer = duration;
        }
    }, 1000);
}

function ToggleAgreements() {
    $(".AgreementHeader").on("click", function () {
        $(this).next(".toggle").slideToggle();
        $(this).find("i").toggleClass("minus-icon");

    });
}


function ToggleMobileExpress() {
    $(".MobilExpressText").on("click", function () {
        if ($(this).parent().find("#SaveMobileExpress").prop("checked")) {
            $(this).parent().find("#SaveMobileExpress").val(false);

        } else {
            $(this).parent().find("#SaveMobileExpress").val(true);
        }
    });
}

function BackHome() {

    $(document).on("click", ".CheckOut a", function (e) {
        if ($(this).attr("href") != "javascript:;" && !$(this).hasClass("ExportToExcel")) {
            $globalhref = $(this).attr("href");
            //console.log($globalhref);
            $("#BackToHomeModal").modal();
            e.preventDefault();
        }
    });

    $("#backHomeYes").on("click", function () {
        $("#BackToHomeModal").modal('toggle');

        window.location.href = $globalhref;
    });





}


function AddInstallmentModal() {
    $(document).on("click", ".CheckOut .PrInstallmentOptions", function (e) {

        var Amount = $("#TotalBasketAmount").val();
        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/CheckOutPayment/GetInstallmentOptions?Amount=" + Amount.replace(".", ""),
            success: function (data) {

                $("#InstallmentModal .modal-body").html("");
                $("#InstallmentModal .modal-body").html(data);
                $("#InstallmentModal").modal('toggle');

            }
        });


    });
}



function AddToolTip() {
    $('.CardTooltip').tooltip({ placement: "right" });

}

function closeForgottenPass() {
    $("#forgottenpassModal").modal("hide");
}


function checkLoginModal() {
    //console.log($("#UserID").val());
    if ($("body").hasClass("loginModal") && $("#UserID").val() == "") {
        $("#LoginRegisterModal").modal();
    }

}

//function clickAddressRow() {

//    $(document).on("click", "#OrderAdress tr", function () {
//        $(this).find("input[type=radio]").trigger("click");
//        $(this).find("input[type=radio]").prop('checked', true);
//    });

//}
function triggerEvent(el, type) {
    if ('createEvent' in document) {
        // modern browsers, IE9+
        var e = document.createEvent('HTMLEvents');
        e.initEvent(type, false, true);
        el.dispatchEvent(e);
    } else {
        // IE 8
        var e = document.createEventObject();
        e.eventType = type;
        el.fireEvent('on' + e.eventType, e);
    }
}

function CheckOutQuickLookLinkResize() {

    var link = $(".BasketProductName a");
    if ($(window).width() < 992) {
        link.attr("href", link.data("url"))
    }
    else {
        link.attr("href", "javascript:;")
    }

}

function CheckOutQuickLook() {


    CheckOutQuickLookLinkResize();
    $(window).resize(function () {
        CheckOutQuickLookLinkResize();
    });

    $(document).on("click", ".BasketProductName", function (e) {
        if ($(window).width() > 991) {
            $("#QuickLookModal .Loader").show();

            if (!window.location.href.indexOf("oxxo.com.tr") || !window.location.href.indexOf("oxxoshop.com") || !$(this).hasClass("BasketProductName")) {
                e.preventDefault();
                return false;
               
            }

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/QuickLook?ProductID=" + $(this).find("a").data("productid") + "&ColorID=" + $(this).find("a").data("colorid") + "&BasketID=" + $(this).find("a").data("basketid"),
                success: function (dt) {
                    $("#QuickLookModal .Content").html("");
                    $("#QuickLookModal .Content").html(dt);
                    $(".CheckOut .ProductContent .Colors .ColorName").html($(".CheckOut .ProductContent .Colors a.active").data("name"));
                    $("#QuickLookModal .Loader").hide();
                    $("#QuickLookModal").modal();
                }

            });



        }
    });


    $(document).on("click", ".CheckOut .ProductContent .ChangeToBasket button", function (e) {
        var Amount = $(".CheckOut .ProductContent .SizeAndAmount #Amount").val();
        var SizeID = $(".CheckOut .ProductContent .SizeAndAmount #SizeID").val();
        var ColorID = $(".CheckOut .ProductContent .Colors #ColorID").val();
        var ProductID = $(".CheckOut .ProductHeader #ProductID").val();
        var LangID = $(".CheckOut .ProductHeader #LangID").val();
        var BasketID = $(".CheckOut .ProductHeader #BasketID").val();

        $basketButton = $(this);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID+"&BasketID="+BasketID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    $basketButton.text(NormalText);
                    //if ($(window).width() < 768) {
                    //    $basketButton.html("<div class='BasketIcon hidden-md hidden-lg'></div>" + NormalText);
                    //}
                    //else {
                    //    $basketButton.text(NormalText);
                    //}

                    //$("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {

                        //console.log($("#QuickLookModal").length);
                        if ($("#QuickLookModal").length > 0) {
                            $("#QuickLookModal").modal("hide");
                            location.reload();
                        }


                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);

                            // console.log("basketParams:" + basketParams);
                        }

                        if (UseTagManager) {

                            SendCartAddEvent('');
                        }


                    }
                    else {

                        alert(dt.IslemSonucAciklama);
                    }


                }
            });
        } else {

            if (SizeID == undefined || SizeID == "") {


                $("#PrdBlackBg").show();
                $(".SizeOptions.open").addClass("PleaseSelect");
                $(".SizeOptions.open").addClass("PleaseSelectChange");
                $(".AddToBasketOuther").addClass("PleaseSelect");


                $('html, body').animate({
                    scrollTop: $(".SizeOptions").offset().top - 150
                }, 500);


                if ($(".AutoTextRep").length > 0) {

                    $(".ChangeToBasket  button").attr("data-first", $(".ChangeToBasket button").text());
                    $(".ChangeToBasket  button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ColorID == undefined || ColorID == "") {

                alert(RenkSec);

                $(".ChangeToBasket button").attr("data-first", $(".ChangeToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".ChangeToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);
        }
    });


    $(document).on("click", ".CheckOut .ProductContent .AddToBasket button", function (e) {
        var Amount = $(".CheckOut .ProductContent .SizeAndAmount #Amount").val();
        var SizeID = $(".CheckOut .ProductContent .SizeAndAmount #SizeID").val();
        var ColorID = $(".CheckOut .ProductContent .Colors #ColorID").val();
        var ProductID = $(".CheckOut .ProductHeader #ProductID").val();
        var LangID = $(".CheckOut .ProductHeader #LangID").val();

        $basketButton = $(this);
        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    $basketButton.text(NormalText);
                  
                    if (dt.Sonuc == true) {

                        //console.log($("#QuickLookModal").length);
                        if ($("#QuickLookModal").length > 0) {
                            $("#QuickLookModal").modal("hide");
                            location.reload();
                        }

                    }
                    else {

                        alert(dt.IslemSonucAciklama);
                    }


                }
            });
        } else {

            if (SizeID == undefined || SizeID == "") {


                $("#PrdBlackBg").show();
                $(".SizeOptions.open").addClass("PleaseSelect");
                $(".SizeOptions.open").addClass("PleaseSelectAdd");
                $(".AddToBasketOuther").addClass("PleaseSelect");


                $('html, body').animate({
                    scrollTop: $(".SizeOptions").offset().top - 150
                }, 500);


                if ($(".AutoTextRep").length > 0) {

                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ColorID == undefined || ColorID == "") {

                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);
        }
    });

    $(document).on("click", ".CheckOut .ProductContent .SizeOptions a", function (e) {


        var TrigAddBasket = false;
        var TrigChangeBasket = false;

        if ($(".CheckOut .ProductContent .SizeOptions.PleaseSelect.PleaseSelectAdd").length == 1) {
            TrigAddBasket = true;
            //console.log("geldii...");
        }
        
        if ($(".CheckOut .ProductContent .SizeOptions.PleaseSelect.PleaseSelectChange").length == 1) {
            TrigChangeBasket = true;
            //console.log("geldii2...")

        }

        
        if (TrigChangeBasket) {

            var Amount = $(".CheckOut .ProductContent .SizeAndAmount #Amount").val();
            var SizeID = $(this).data('id');
            var ColorID = $(".CheckOut .ProductContent .Colors #ColorID").val();
            var ProductID = $(".CheckOut .ProductHeader #ProductID").val();
            var LangID = $(".CheckOut .ProductHeader #LangID").val();
            var BasketID = $(".CheckOut .ProductHeader #BasketID").val();

            //console.log(Amount + "-" + SizeID + "-" + ColorID + "-" + ProductID + "-" + LangID + "-" + BasketID);

            $basketButton = $(".CheckOut .ProductContent .ChangeToBasket button");

            if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
                var NormalText = $basketButton.text();
                var AddingText = $basketButton.attr("data-adding");
                $basketButton.text(AddingText);

                $.ajax({
                    type: 'get',
                    url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                    data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID + "&BasketID=" + BasketID,
                    dataType: 'json',
                    async: true,
                    success: function (dt) {
                        $basketButton.text(NormalText);
            
                        if (dt.Sonuc == true) {

                           // console.log($("#QuickLookModal").length);
                            if ($("#QuickLookModal").length > 0) {
                                $("#QuickLookModal").modal("hide");
                                location.reload();
                            }


                        }
                        else {

                            alert(dt.IslemSonucAciklama);
                        }


                    }
                });
            }
        }



        if (TrigAddBasket) {

            var Amount = $(".CheckOut .ProductContent .SizeAndAmount #Amount").val();
            var SizeID = $(this).data('id');
            var ColorID = $(".CheckOut .ProductContent .Colors #ColorID").val();
            var ProductID = $(".CheckOut .ProductHeader #ProductID").val();
            var LangID = $(".CheckOut .ProductHeader #LangID").val();

            //console.log(Amount + '--' + SizeID + '--' + ColorID + '--' + ProductID + '--' + LangID);
            $basketButton = $(".CheckOut .ProductContent .AddToBasket button");
            //$(".CheckOut .ProductContent .AddToBasket button").trigger("click");

            if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {

                var NormalText = $basketButton.text();
                var AddingText = $basketButton.attr("data-adding");
                $basketButton.text(AddingText);

                $.ajax({
                    type: 'get',
                    url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                    data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID,
                    dataType: 'json',
                    async: true,
                    success: function (dt) {
                        $basketButton.text(NormalText);
                      
                        if (dt.Sonuc == true) {

                            //console.log($("#QuickLookModal").length);
                            if ($("#QuickLookModal").length > 0) {
                                $("#QuickLookModal").modal("hide");
                                location.reload();
                            }


                        }
                        else {

                            alert(dt.IslemSonucAciklama);
                        }


                    }
                });
            }
        }

        if ($(".LastProducts").length > 0) {

            var params = "ProductID=" + $("#ProductID").val() + "&ColorID=" + $("#ColorID").val() + "&SizeID=" + $("#SizeID").val();

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/StokWarn",
                data: params,
                success: function (data) {

                    if (data != "0" && data != 0 && data < 5) {

                        $(".SizeAndAmount .LastProducts .LastX").html(data);
                        $(".SizeAndAmount .LastProducts").css("display", "inline-block");
                    }
                    else {
                        $(".SizeAndAmount .LastProducts").hide();
                    }

                }

            });

        }

        $(".CheckOut .ProductContent .SizeOptions a").removeClass("active");
        $(this).addClass("active");
        $(".CheckOut .ProductContent .SizeAndAmount #SizeID").val($(this).data("id"));
    });

    $(document).on("click", ".CheckOut .PrdImgRight", function (e) {
        var ImageList = $(".ProductDetailImages .pdImageList");
        var ImageListItem = $(".ProductDetailImages .pdImageList li");

        var active = $(".ProductDetailImages .pdImageList li.active")

        ImageListItem.removeClass("active");
        //console.log(active.index());
        console.log(ImageListItem.size());
        if ((active.index()+1) == ImageListItem.size()) {
            $(".ProductDetailImages .pdImageList li:first-child").addClass("active");
        } else {
            active.next().addClass("active");
        }

    });

    $(document).on("click", ".CheckOut .PrdImgLeft", function (e) {
        var ImageList = $(".ProductDetailImages .pdImageList");
        var ImageListItem = $(".ProductDetailImages .pdImageList li");

        var active = $(".ProductDetailImages .pdImageList li.active")

        ImageListItem.removeClass("active");

        if (active.index() == 0) {
            $(".ProductDetailImages .pdImageList li:last-child").addClass("active");
        } else {
            active.prev().addClass("active");
        }
    });

    $(document).on("click", ".CheckOut .ProductContent .Colors a", function (e) {

        $(".CheckOut .ProductContent .Colors a").removeClass("active");
        $(this).addClass("active");
        $(".CheckOut .ProductContent .Colors #ColorID").val($(this).data("id"));

        $(".CheckOut .ProductContent .Colors .ColorName").html($(this).data("name"));


        var params = "ColorID=" + $(this).attr("data-id") + "&ProductID=" + $(this).attr("data-productid");

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetAllDetailInfoByColorID",
            data: params,
            success: function (data) {
                console.log(data);
                $(".SizeOptions").html("");
                $(".ProductDetailImages .pdImageList").html("");
                var j = 0;

                var stockImages = data.filter(function (item) { return item.Type == "StockImage" }).reverse();
                console.log(stockImages);
                for (var k = 0; k < stockImages.length; k++) {

                    if (stockImages[k].Type == "StockImage") {
                        var url = stockImages[k].Name.replace(/\/$/g, "");

                        var img = $("<img src='" + url + "'/>")
                        var li = $("<li></li>");
                        li.addClass('ImgArea');
                        if (j == 0) {
                            li.addClass('active');
                        }
                        li.append(img);


                        $(".ProductDetailImages .pdImageList").append(li);
                        j++
                    }
                }

                for (var i = 0; i < data.length; i++) {



                    if (data[i].Type == "Size") {

                        var stil = "";
                        //$(".SizeOptions").html("");
                        if (data[i].InStock == false || data[i].PStatus != 1) {

                            stil = "OutOfQuantity";

                            if ($(".NewPD").length > 0) {
                                $(".SizeOptions").append('<span class=\"outer\">' +
                                    '  <span class="PdHint"> <span class="PdHint-content">Bu Ürünün ' + data[i].Name + ' Bedeni Stoklarla Kalmamıştır.<br />' +
                                        '<a href="#" class="NotifyWhen">Ürün stoğa geldiğinde haber ver!</a>' +
                                    ' </span></span>'
                                    + '<span class=\"inner\">' + data[i].Name + '</span></span>');



                            } else {
                                $(".SizeOptions").append('<span class=\"outer\"><span class=\"inner\">' + data[i].Name + '</span></span>');
                            }

                            //$('.AddToRemindList').show();

                        }

                        else {
                            $(".SizeOptions").append('<a data-id="' + data[i].ID + '" data-stock="' + data[i].InStock + '" data-name="' + data[i].Name + '" href="javascript:;" class="' + stil + " " + data[i].Name + '">' + data[i].Name + '</a>');
                        }

                    }

                }

            }
        });

    });

}


function KvkkModal() {
    $(document).on("click", ".KVKKTrigger", function () {
        $("#KVKKModal").modal();
    });
}


//function MobileKeyboardListener() {

//    $(document).on('focus', '.OrderAdressForm input,.OrderAdressForm textarea, #CouponForm input,#CardForm input', function () {
//        if (!$('body').hasClass('keyboardOpened')) {
//            $('body').addClass('keyboardOpened');
//        }
//    });

//    $(document).on('blur', '.OrderAdressForm input,.OrderAdressForm textarea, #CouponForm input,#CardForm input', function () {
//        $('body').removeClass('keyboardOpened');
//    });


//}




$(document).ready(function () {

    GetAdressFromFirstLoad();
    checkLoginModal();
    PrepareAddressAndPayment();
    ToggleAgreements();
    ToggleMobileExpress();
    BackHome();
    AddInstallmentModal();
    AddToolTip();
    CheckOutQuickLook();
    KvkkModal();
   
    if ($(".SingleLineCart").length > 0) {
        isSingleLineCreditCard = true;
    }

    //if ($(window).width() <= 768) {
    //    MobileKeyboardListener();
    //}


    //SetStep Validate and Navigate
    $("body").on("click", "#Steps button, #Steps .StepName, #nextbtn, #backbtn", function () {

        var adim = $(this).attr("data-next");
        var href = $(this).attr("data-href");

        if (href != undefined && href != "") {
            document.location.href = href;
            return;
        }

        if ($(".PaymentDetail.KrediKarti").hasClass("active") && adim == "progress") {
            SetCreditCartAndStep(adim, href);

        } else {
            SetStep(adim, href);
        }



    });


    //$(".withoutMember").on("click", function () {

    //    $.ajax({
    //        type: 'get',
    //        url: "/" + $("#SmallLangCode").val() + "/p/" + CheckOutValidator + "/SetMemberless?memberless=true",
    //        success: function (dt) {

    //            ReloadOnTimeOut(dt);

    //            if (dt.Status == true) {

    //                //SetStep(adim, href);
    //                //Sipariş özetini Yenile
    //                //RefreshOrderSummary(true, true); 
    //            }
    //            else {

    //                SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
    //            }

    //        }

    //    });

    //});

    $("#LoginRegisterModal").on("click", ".ContinueWithoutMember", function (e) {

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/" + CheckOutValidator + "/SetMemberless?memberless=true",
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {
                    location.reload();
                    //SetStep(adim, href);
                    //Sipariş özetini Yenile
                    //RefreshOrderSummary(true, true); 
                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                }

            }

        });

        return false;
        e.preventDefault();

    });


    //Cart Change Delete 
    $('input.sepetAdet').keyup(function () {

        var updateID = $(this).attr("data-id");
        var yeniAdet = $(this).val();
        var adetKutusu = $(this);
        var LangID = $("#LangID").val();

        if (yeniAdet <= 1) {
            $(adetKutusu).val(1);
        }
        else if (yeniAdet >= 9) {
            $(adetKutusu).val(9);
        }

        //update'den Sonra
        var sepetToplami = 0;


        var ToplamAdet = $("#ustSepetAdet").html();

        var guncellenecekContainerObje = $(this).parent().parent();

        $(guncellenecekContainerObje).find(".ustSepetAjaxLoader").show();
        $(guncellenecekContainerObje).find(".ustSepetDelete").hide();

        $(guncellenecekContainerObje).css("opacity", "0.5");

        $.ajax({
            type: 'get',
            url: '/Cart/UpdateCartAmount',
            data: 'id=' + updateID + "&adet=" + yeniAdet + "&langID=" + LangID,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            cahce: false,
            success: function (dt) {
                if (dt.Sonuc == true) {
                    ReloadPage();
                }
                else {
                    alert(dt.IslemSonucAciklama);
                }
                $(guncellenecekContainerObje).find(".ustSepetAjaxLoader").hide();
                $(guncellenecekContainerObje).find(".ustSepetDelete").show();
                $(guncellenecekContainerObje).css("opacity", "1");


            }
        });


        //ISNUMERIC ADET SONU

    });


    $(".SmsFirstStep").on("click", function () {
        $.ajax({
            type: 'GET',
            url: "/" + $("#SmallLangCode").val() + '/p/CheckOutPayment/SmsComfirmationStepOne',
            success: function (dt) {

                $(".SmsOnayArea").html("");
                $(".SmsOnayArea").html(dt);

                var fiveMinutes = 60 * 3,
                   display = $('.geriSayim .counter');
                startTimer(fiveMinutes, display);

            }
        });
    });



    $(document).on("submit", "#SmsForm", function (e) {
        e.preventDefault();
        $.ajax({
            type: 'post',
            url: $("#SmsForm").attr("action"),
            data: $("#SmsForm").serialize(),
            async: true,
            success: function (dt) {
                console.log(dt);
                if (dt.Status) {
                    var successText = "";
                    for (var i in dt.ResultDescription) {
                        successText += " " + dt.ResultDescription[i];
                    }
                    $(".SmsOnayArea").html("");
                    $(".SmsOnayArea").html("<div id='Success' class='alert alert-success'>" + successText + "</div>");
                    $(".SmsOnayInfo").hide();
                }
                else {
                    var errorText = "";
                    for (var i in dt.ResultDescription) {
                        errorText += " " + dt.ResultDescription[i];
                    }

                    $("#Erros").html(errorText);
                    $("#Erros").show();
                }
            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }
        });

    });

    //Amount Option Change
    $('.BasketDetails .GenMinus, .BasketDetails .GenPlus').click(function () {

        $SepetAdet = $(this).closest(".BasketDetails").find("input.sepetAdet");
        if ($(this).hasClass("GenPlus") == true) {
            if ($SepetAdet.val() >= 9) {
                $SepetAdet.val(parseInt(9));
            }
            else {
                $SepetAdet.val(parseInt($SepetAdet.val()) + 1);
            }
        }
        else {
            $SepetAdet.val(parseInt($SepetAdet.val()) - 1);
        }

        if ($SepetAdet.val() != "0") {

            $SepetAdet.trigger('keyup');
        }
        else {

            $SepetAdet.val(1)
        }

    });

    $("#OrderBasket .RemoveIcon, .LeftBasketItem div.row div.col-xs-3 div.RemoveIcon").click(function () {


        var Silid = $(this).attr("data-id").replace("sepetsil", "");
        var LangID = $("#LangID").val();

        $(this).closest(".LeftBasketItem").css("opacity", "0.5");

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
            data: 'id=' + Silid + "&langID=" + LangID,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {

                //ReloadOnTimeOut(dt);

                if (dt.Sonuc == false) {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                } else {
                    ReloadPage();
                }
            }
        });


    });

    //COUPON
    $("#CouponForm").submit(function (e) {

        couponCode = $("#CouponCodeInput", $(this)).val();

        UseCoupon(couponCode);

        e.preventDefault();
        return false;
    });

    $("body .UsetCouponTd").click(function (e) {

        couponCode = $(this).attr("data-value");

        UseCoupon(couponCode);

        e.preventDefault();
        return false;
    });

    $("body").on("click", ".RemoveCoupon", function (e) {

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + '/p/CheckOutCart/RemoveCoupon',
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {

                if (dt.Sonuc == false) {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                } else {

                    RefreshOrderSummary(false, false);
                    $("#OrderCoupons tr").removeClass("added");
                }
            }
        });

        e.preventDefault();
        return false;

    });

    //END CCOUPON

    //Adress Create And Edit
    $("body").on("click", ".AdresPopup", function () {

        if ($(".AdressFormLoaded").length > 0 && $(".OrderAdressForm").length > 0) {
            $(".OrderAdressForm").slideToggle();
            $(this).toggleClass("on");

        } else {
            $(this).addClass("opened");
            $(this).addClass("on");
            $(this).addClass("AdressFormLoaded")
            var url = $(this).attr("data-href");

            GetAddressForm(url);
        }



    });



    $("#OrderAdress").on("click", ".RemoveIcon", function () {

        $(this).closest("tr").css("opacity", "0.5");
        var id = $(this).attr("data-id");

        var url = "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/Delete?adresid=" + id;

        $.ajax({
            type: 'post',
            url: url,
            dataType: 'json',
            success: function (data) {

                ReloadOnTimeOut(data);

                if (data.Status == true) {

                    $("#OpStatusBar div.alert-success ul li").html(data.ResultDescription[0]);
                    $("#OpStatusBar > div.alert-sucess ").show();

                    ReloadPure();

                }
                else {

                    SetErrorResults($("#OpStatusBar div.alert-danger ul li"), data.ResultDescription, true, false);
                    $("#OpStatusBar > div.alert-danger ").show();
                }

            },
            error: function (data) {

                $("#Errors .alert-error").html(data.ResultDescription[0]);
            }
        });


    });


    $("body").on("change", ".ddl_ulke", function () {

        var seciliUlkeID = $(this).val();
        $(".ajaxilce").show();

        $.ajax({
            type: 'get',
            url: '/User/GetCities',
            data: 'countryid=' + seciliUlkeID,
            dataType: 'json',
            success: function (dt) {

                var icerik = "";

                $('#CityID option').remove();
                $('.ddl_sehir option').remove();
                $('.ddl_ilce option').remove();
                $('.ddl_mahalle option').remove();

                $('#CityID')
                     .append($("<option selected='selected'></option>")
                     .attr("value", "")
                     .text("Lütfen Seçin"));


                $('#CityID').parent().find("span").html("Lütfen Seçin");

                for (var i = 0; i < dt.length; i++) {


                    $('#CityID')
                     .append($("<option></option>")
                     .attr("value", dt[i].ID)
                     .text(dt[i].Name));

                }

                $(".ajaxilce").hide();


            }
        });

        RefReshCityAndTowns();

    });

    $("body").on("change", ".ddl_sehir", function () {

        var seciliSehirOID = $(this).val();
        $(".ajaxilce").show();

        $.ajax({
            type: 'get',
            url: '/User/GetTowns',
            data: 'cityid=' + seciliSehirOID,
            dataType: 'json',
            success: function (dt) {

                var icerik = "";
                $('#TownID option').remove();

                $('#TownID')
                     .append($("<option selected='selected' ></option>")
                     .attr("value", "")
                     .text("Lütfen Seçin"));


                $('#TownID').parent().find("span").html("Lütfen Seçin");

                for (var i = 0; i < dt.length; i++) {

                    $('#TownID')
                     .append($("<option></option>")
                     .attr("value", dt[i].ID)
                     .text(dt[i].Name));

                }

                $(".ajaxilce").hide();


            }
        });


    });

    $("body").on("change", ".ddl_ilce", function () {

        var seciliIlceID = $(this).val();
        $(".ajaxilce").show();

        $.ajax({
            type: 'get',
            url: '/User/GetQuarters',
            data: 'TownID=' + seciliIlceID,
            dataType: 'json',
            success: function (dt) {

                var icerik = "";
                $('#QuarterID option').remove();

                $('#QuarterID')
                     .append($("<option selected='selected' ></option>")
                     .attr("value", "")
                     .text("Lütfen Seçin"));


                $('#QuarterID').parent().find("span").html("Lütfen Seçin");

                for (var i = 0; i < dt.length; i++) {

                    $('#QuarterID')
                     .append($("<option></option>")
                     .attr("value", dt[i].ID)
                     .text(dt[i].Name));

                }

                $(".ajaxilce").hide();


            }
        });


    });

    $("#AddressArea").on("submit", "form.OrderAdressForm", function (e) {

        $form = $(this);
        $("#OpStatusBar div").hide();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            cache: false,
            success: function (data) {

                ReloadOnTimeOut(data);

                if (data.Status == true) {

                    $("#OpStatusBar div.alert-success ul li").html(data.ResultDescription[0]);
                    $("#OpStatusBar > div.alert-sucess ").show();


                    ReloadPure();

                }
                else {

                    SetErrorResults($("#OpStatusBar div.alert-danger ul li"), data.ResultDescription, true, false);
                    $("#OpStatusBar > div.alert-danger ").show();
                }

            },
            error: function (data) {

                $("#Errors .alert-error").html(data.ResultDescription[0]);
            }

        });

        e.preventDefault();
        return false;

    });

    var deliverCheckedVal = 0;
    var billingCheckedVal = 0;

    if ($("#OrderAdress input[name=adr_del]:checked").length > 0) {
        deliverCheckedVal = $("#OrderAdress input[name=adr_del]:checked").val();
    }

    if ($("#OrderAdress input[name=adr_bil]:checked").length > 0) {

        billingCheckedVal = $("#OrderAdress input[name=adr_bil]:checked").val();
    }

    //SetAdres
    $("#OrderAdress").on("change", "input[type=radio]", function (e) {

        var adrtype = $(this).attr("data-adrtype");
        var id = $(this).val();
        $clicked = $(this);

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/SetAddress?addressID=" + id + "&addressType=" + adrtype,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status) {

                    //Sipariş özetini Yenile
                    RefreshOrderSummary(false, false);
                    //KargoListesini Yenile 

                    if (adrtype == "Delivery") {
                        RefreshCargoList();
                    }

                    $("#AddressArea").html("");
                    $(".AddAdress").removeClass("AdressFormLoaded");
                    $(".AddAdress").removeClass("opened");
                    $(".AddAdress").removeClass("on");

                }

                if (dt.Status == false && dt.StatusText == "InvalidAddress" && $("#AddressArea").length > 0) {

                    var url = "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/EditOrCreate?id=" + id;

                    GetAddressForm(url);

                } else if (dt.Status == false) {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                }

                if (dt.Status == false) {

                    //Remove Checked Status Before go
                    if (adrtype == "Delivery") {

                        $("#OrderAdress input[name=adr_del]").removeAttr("checked");
                        $("#OrderAdress input[name=adr_del][value=" + deliverCheckedVal + "]").prop("checked", "checked");

                    } else if (adrtype == "Billing") {

                        $("#OrderAdress input[name=adr_bil]").removeAttr("checked");
                        $("#OrderAdress input[name=adr_bil][value=" + billingCheckedVal + "]").prop("checked", "checked");

                    }
                }
                else {

                    if (adrtype == "Delivery") {

                        deliverCheckedVal = id;

                    } else if (adrtype == "Billing") {

                        billingCheckedVal = id;

                    }

                }
            }

        });
        if (adrtype != "Billing") {
            $(this).closest("tr").find(".billingClass").trigger("change");
        }

    });

    //SetKargo

    var selectedCargoPriceID = 0;

    if ($("#CargoTable input:checked").length > 0) {
        selectedCargoPriceID = $("#CargoTable input:checked").val();
    }

    //$("body").on("click", "#OrderAdress td", function () {

    //    $lbl = $(this).find("label");

    //    console.log($lbl.length);

    //    if ($lbl.length <= 0) {

    //        $(this).closest("tr").find("label").trigger("click");
    //    } 
    //});

    $("body").on("click", "#CargoTable td", function () {

        $lbl = $(this).find("label");

        console.log($lbl.length);

        if ($lbl.length <= 0) {

            $(this).closest("tr").find("label").trigger("click");
        }
    });

    $("#GiftTable").on("change", "input", function () {

        var wantGift = $(this).is(":checked");

        console.log("gift status : ", wantGift);

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutCart/SetGift?wantGift=" + wantGift,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();

                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                    $("#GiftTable input").removeProp("checked");
                    $("#GiftTable input[value=" + selectedCargoPriceID + "]").prop("checked", "checked");
                }
            }

        });

    });



    $("body").on("click", "#GiftTable td:not(.RadioTd)", function (e) {

        console.log("tr clicked");

        $radinput = $(this).closest("tr").find("input:first");
        $radinput.prop("checked", !$radinput.is(":checked"));
        $(this).closest("tr").find("input").trigger("change");

    });


    $("body").on("change", "#PaymentGroups input, .WebPosItem input, #BankList input,#PayAtDoor input", function (e) {

        $label = $(this).closest("label");
        $input = $(this);

        var paymentType = $input.attr("data-payment");
        var paymentTypeValue = $input.val();

        var webposinstallmentid = $input.attr("data-webposinstallment-id");
        var bankid = $input.attr("data-bankid");

        $("#PaymentGroups input").removeProp("checked");
        $("#PaymentGroups label, .TaksitLabel").removeClass("active");

        $label2 = $("#PaymentGroups label input[data-payment='" + paymentType + "']:first").closest("label");


        $label.addClass("active");
        $label2.addClass("active");

        $label.find("input").prop("checked", "checked");



        $(".PaymentDetail").removeClass("active");
        $(".PaymentDetail." + paymentType).addClass("active");

        if ($(this).closest("#PaymentGroups").length > 0) {

            $("#Erros").html("");
            $("#Erros").hide();
            $(".WebPosItem").hide();

            var webPosId = $(".WebPosItem.active").attr("data-webposid");

            $(".WebPosItem[data-webposid='" + webPosId + "']").show();
            //$(".WebPosItem[data-cardtype='" + paymentType + "']").show();


        }

        SetPaymentType(webposinstallmentid, bankid);

    });


    $("body").on("click", ".PosGroupItem", function (e) {
        $(".PosGroupItem").removeClass("active");
        $(this).addClass("active");
        var webPosId = $(this).attr("data-webposid");

        $(".WebPosItem").hide();
        $(".WebPosItem[data-webposid='" + webPosId + "']").show();

    });

    $("body").on("keyup", "#CardNumbers input", function (e) {

        var cr_1 = $("#CardNumbers > input#CardNumber1").val().replace(/\D/g, '');
        cr_1 = formatCC(cr_1);
        $("#CardNumbers > input#CardNumber1").val(cr_1);

        var cardNumber = cr_1.replace(/\D/g, '');

        isAllValid = false;

        if (cardNumber.length == 16 && validateCardNumber(cardNumber) == false) {

            $("#CardNumbers > input").addClass("NotValid");
            isAllValid = false;

        } else {
            $("#CardNumbers > input").removeClass("NotValid");
            isAllValid = true;
        }


        if (IsNumeric($(this).val().replace(/\D/g, '')) == false && $(this).val() != "" && $(this).hasClass("cardno")) {

            $(this).addClass("NotValid");
        }
        else {

            if (isAllValid || cardNumber.length < 16 || !$(this).hasClass("cardno")) {
                $(this).removeClass("NotValid");
            }

            if (isAllValid) {
                $("#CardNumbers > input").removeClass("NotValid");
            }
        }



        CheckBinNumber();

        //if ($(this).attr("id") == "CardOwner" && IsNumeric($(this).val().replace(/\D/g, ''))) {

        //    $(this).addClass("NotValid");
        //    $(".CardOwnerHeader").addClass("MoveNeeded");
        //}
        //else if ($(this).attr("id") == "CardOwner") {

        //    $(this).removeClass("NotValid");
        //    $(".CardOwnerHeader").removeClass("MoveNeeded");

        //}

    });


    $(document).on("change", "#CargoTable input", function () {

        var id = $(this).val();
        $clicked = $(this);

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutAddress/SetCargoPrice?cargoPriceID=" + id,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();
                    selectedCargoPriceID = id;

                }
                else {


                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                    $("#CargoTable input").removeProp("checked");
                    $("#CargoTable input[value=" + selectedCargoPriceID + "]").prop("checked", "checked");

                }
            }

        });

    });

    $("body").on("change", "#AggrementApprove", function () {

        var IsApproved = $(this).is(":checked");

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetAgreement?isApproved=" + IsApproved,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();

                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                }
            }

        });

    });



    //LOGIN & REGISTER
    var UseTagManager = false;
    $("body").on("submit", "form.UyeGiris", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {

                        AddUserAction("Login");
                    }

                    if (dt.JsonRs == "Reload") {

                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                        $(".AjaxLoader").show();
                        $form.hide();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();

                    }

                    if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = dt.Deger5;
                    }

                    $("#AlertResult").removeClass("alert-danger");

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }


                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("body").on("submit", "form.UyeOl", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("Signup");
                    }

                    if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = "/";
                    }

                    if (dt.JsonRs == "Reload") {

                        $form.hide();

                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();
                    }

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").hide();
                    //$("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);



                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }

                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("#UserWelcome a").on("click", function () {

        $("#LoginRegisterModal").modal('show');

    });




    $("body").on("click", "a.RegisterIcon, a.LoginIcon, #CheckoutHeader .RegisterIcon a, #CheckoutHeader  .LoginIcon a, #CheckoutHeader  a.RegisterIcon , #CheckoutHeader  a.LoginIcon", function (e) {

        $("#LoginRegisterModal").modal('show');

        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

            var swparams = GetSwPageParams();
            swparams = ChangeSwHashedStringParamValue(swparams, "ActionType", "SiparisUyelikPopupAcma");
            AddSwAction(swparams);

        }

        if (UseTagManager) {
            AddCheckOutView('', 2);
            SendGaDataLayerVirtual();
        }

        if ($(this).closest("li").hasClass("RegisterIcon") || $(this).hasClass("RegisterIcon")) {

            if ($(".UyeKayitCol").hasClass("pull-right") == false) {

                $(".RegisterInBanner").trigger("click");
            }

        }
        else {
            if ($(".UyeKayitCol").hasClass("pull-right")) {

                $(".RegisterInBanner").trigger("click");
            }
        }

        e.preventDefault();
        return false;
    });

    $("body").on("click", "#ReadAgreement", function (e) {

        $("#AgreementModal .modal-body").html($("#AgreementDetails").html() + $("#OnBilgilendirmetails").html());
        $("#AgreementModal").modal('show');

        return false;
    });

    $("#UserWelcome").on("click", "a.Popup", function (e) {

        $("#LoginRegisterModal").modal('show');

        e.preventDefault();
        return false;
    });


    $("body .LogRegTabs").on("click", "li.tb", function (e) {

        var target = $(this).attr("data-target");

        //console.log(target);

        $(".Tab1, .Tab2").hide();
        $("." + target).show();

        $(".LogRegTabs li").removeClass("active");
        $(this).addClass("active");

        e.preventDefault();
        return false;
    });


    $("body").on("click", ".ForgetPass", function (e) {

        $("#forgottenpassModal").modal('show');

    });

    $("body").on("submit", "form.ForgettenForm", function () {

        $form = $("form.ForgettenForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {

                if (dta.Sonuc == true) {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);

                    $("#email").hide();
                    $("#forgottenPassSubmit").hide();
                    setInterval(closeForgottenPass, 3000);
                    $(".ForgettenForm p:first").removeClass("alert-danger");
                    $(".ForgettenForm p:first").addClass("alert alert-success");

                }
                else {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);
                    $(".ForgettenForm p:first").addClass("alert alert-danger");
                }



            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });


    //LOGIN & REGISTER END


});




/* KEYBOARD DETECT */

function updateWindowSize() {
    window.lastInnerWidth = window.innerWidth;
    window.lastInnerHeight = window.innerHeight;
    window.lastOrientation = window.orientation;
    window.lastBodyHeight = document.body.clientHeight;
};

function detectKeyboard() {
    function orientationChange() {
        if (((window.lastOrientation == 0 || window.lastOrientation == 180) && (window.orientation == 0 || window.orientation == 180)) || ((window.lastOrientation == 90 || window.lastOrientation == -90) && (window.orientation == 90 || window.orientation == -90))) return false
        else return true;
    }

    if ((window.lastInnerHeight - window.innerHeight > 150) && window.innerWidth == window.lastInnerWidth) {
        var keyboardHeight = window.lastInnerHeight - window.innerHeight;
        updateWindowSize();
        return keyboardHeight;
    }

    if (orientationChange() && document.body.classList.contains("keyboard-open")) {
        var keyboardHeight = screen.height - window.topBarHeight - window.innerHeight;
        updateWindowSize();
        return keyboardHeight;
    }

    if ((window.innerHeight - window.lastInnerHeight > 150) && window.innerWidth == window.lastInnerWidth) {
        var keyboardHeight = -1;
        updateWindowSize();
        return keyboardHeight;

    }

    var keyboardHeight = 0;
    updateWindowSize();
    return keyboardHeight;
};

function keyboardShift(keyboardHeight) {
    if (!document.body.classList.contains("keyboard-open")) document.body.classList.add("keyboard-open");
    document.body.setAttribute("style", "height: calc(100% + " + keyboardHeight + "px);");
};

function removeKeyboardShift() {
    document.body.classList.remove("keyboard-open");
    document.body.removeAttribute("style");
};

(function () {

    if ($(window).width() <= 768) {
        updateWindowSize();
        window.topBarHeight = screen.height - window.innerHeight;
        window.addEventListener("resize", resizeThrottler, false);

        var resizeTimeout;
        function resizeThrottler() {
            if (!resizeTimeout) {
                resizeTimeout = setTimeout(function () {
                    resizeTimeout = null;
                    actualResizeHandler();
                }, 66);
            }
        }

        function actualResizeHandler() {
            var keyboardHeight = detectKeyboard();
            if (keyboardHeight > 0) { keyboardShift(keyboardHeight); }
            else if (keyboardHeight == -1) { removeKeyboardShift(); }
        }
    }


}());

/* KEYBOARD DETECT -- END */